"use strict";
Object.defineProperty(exports, "__esModule", {
    value: true
});
Object.defineProperty(exports, "default", {
    enumerable: true,
    get: function() {
        return Settings;
    }
});
var _react = /*#__PURE__*/ _interopRequireWildcard(require("react"));
function _extends() {
    _extends = Object.assign || function(target) {
        for(var i = 1; i < arguments.length; i++){
            var source = arguments[i];
            for(var key in source){
                if (Object.prototype.hasOwnProperty.call(source, key)) {
                    target[key] = source[key];
                }
            }
        }
        return target;
    };
    return _extends.apply(this, arguments);
}
function _getRequireWildcardCache(nodeInterop) {
    if (typeof WeakMap !== "function") return null;
    var cacheBabelInterop = new WeakMap();
    var cacheNodeInterop = new WeakMap();
    return (_getRequireWildcardCache = function(nodeInterop) {
        return nodeInterop ? cacheNodeInterop : cacheBabelInterop;
    })(nodeInterop);
}
function _interopRequireWildcard(obj, nodeInterop) {
    if (!nodeInterop && obj && obj.__esModule) {
        return obj;
    }
    if (obj === null || typeof obj !== "object" && typeof obj !== "function") {
        return {
            default: obj
        };
    }
    var cache = _getRequireWildcardCache(nodeInterop);
    if (cache && cache.has(obj)) {
        return cache.get(obj);
    }
    var newObj = {};
    var hasPropertyDescriptor = Object.defineProperty && Object.getOwnPropertyDescriptor;
    for(var key in obj){
        if (key !== "default" && Object.prototype.hasOwnProperty.call(obj, key)) {
            var desc = hasPropertyDescriptor ? Object.getOwnPropertyDescriptor(obj, key) : null;
            if (desc && (desc.get || desc.set)) {
                Object.defineProperty(newObj, key, desc);
            } else {
                newObj[key] = obj[key];
            }
        }
    }
    newObj.default = obj;
    if (cache) {
        cache.set(obj, newObj);
    }
    return newObj;
}
function _objectWithoutProperties(source, excluded) {
    if (source == null) return {};
    var target = _objectWithoutPropertiesLoose(source, excluded);
    var key, i;
    if (Object.getOwnPropertySymbols) {
        var sourceSymbolKeys = Object.getOwnPropertySymbols(source);
        for(i = 0; i < sourceSymbolKeys.length; i++){
            key = sourceSymbolKeys[i];
            if (excluded.indexOf(key) >= 0) continue;
            if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue;
            target[key] = source[key];
        }
    }
    return target;
}
function _objectWithoutPropertiesLoose(source, excluded) {
    if (source == null) return {};
    var target = {};
    var sourceKeys = Object.keys(source);
    var key, i;
    for(i = 0; i < sourceKeys.length; i++){
        key = sourceKeys[i];
        if (excluded.indexOf(key) >= 0) continue;
        target[key] = source[key];
    }
    return target;
}
function Settings(_param) {
    var title = _param.title, props = _objectWithoutProperties(_param, [
        "title"
    ]);
    return /*#__PURE__*/ _react.createElement("svg", _extends({
        width: "24",
        height: "24",
        viewBox: "0 0 24 24",
        fill: "none",
        xmlns: "http://www.w3.org/2000/svg",
        "aria-hidden": !!title
    }, props), title ? /*#__PURE__*/ _react.createElement("title", null, title) : null, /*#__PURE__*/ _react.createElement("path", {
        fillRule: "evenodd",
        clipRule: "evenodd",
        d: "M12 10C10.8954 10 10 10.8954 10 12C10 13.1046 10.8954 14 12 14C13.1046 14 14 13.1046 14 12C14 10.8954 13.1046 10 12 10ZM8 12C8 9.79086 9.79086 8 12 8C14.2091 8 16 9.79086 16 12C16 14.2091 14.2091 16 12 16C9.79086 16 8 14.2091 8 12Z"
    }), /*#__PURE__*/ _react.createElement("path", {
        fillRule: "evenodd",
        clipRule: "evenodd",
        d: "M8.99996 3C8.99996 2.44772 9.44768 2 9.99996 2H14C14.5522 2 15 2.44772 15 3V4.58179C15.6952 4.86319 16.3415 5.23924 16.9229 5.69365L18.2942 4.90192C18.7725 4.62578 19.3841 4.78966 19.6602 5.26795L21.6602 8.73205C21.7928 8.96174 21.8288 9.23469 21.7601 9.49087C21.6915 9.74705 21.5239 9.96547 21.2942 10.0981L19.9234 10.8895C19.9739 11.2528 20 11.6236 20 12C20 12.3764 19.9739 12.7472 19.9234 13.1105L21.2942 13.9019C21.7725 14.1781 21.9364 14.7897 21.6602 15.2679L19.6602 18.732C19.3841 19.2103 18.7725 19.3742 18.2942 19.0981L16.9229 18.3064C16.3415 18.7608 15.6952 19.1368 15 19.4182V21C15 21.5523 14.5522 22 14 22H9.99996C9.44768 22 8.99996 21.5523 8.99996 21V19.4182C8.30472 19.1368 7.65846 18.7607 7.07707 18.3063L5.70573 19.0981C5.47605 19.2307 5.20309 19.2666 4.94691 19.198C4.69073 19.1293 4.47232 18.9617 4.33971 18.7321L2.33971 15.2679C2.06357 14.7897 2.22744 14.1781 2.70573 13.9019L4.07656 13.1105C4.02605 12.7472 3.99998 12.3764 3.99998 12C3.99998 11.6236 4.02605 11.2528 4.07656 10.8895L2.70573 10.0981C2.22744 9.82193 2.06357 9.21034 2.33971 8.73205L4.33971 5.26795C4.47232 5.03826 4.69073 4.87067 4.94691 4.80202C5.20309 4.73338 5.47605 4.76932 5.70573 4.90192L7.07707 5.69367C7.65846 5.23925 8.30472 4.86321 8.99996 4.58181V3ZM11 4V5.28989C11 5.7323 10.7093 6.12214 10.2852 6.24834C9.3741 6.5195 8.55247 7.00201 7.87768 7.64032C7.55636 7.94427 7.07353 8.00102 6.69049 7.77987L5.57176 7.13397L4.57176 8.86603L5.68907 9.5111C6.07181 9.73208 6.26411 10.1781 6.16203 10.6081C6.05622 11.0538 5.99998 11.5197 5.99998 12C5.99998 12.4803 6.05622 12.9462 6.16203 13.3919C6.26411 13.8219 6.07181 14.2679 5.68907 14.4889L4.57176 15.134L5.57176 16.866L6.69049 16.2201C7.07353 15.999 7.55636 16.0557 7.87768 16.3597C8.55247 16.998 9.3741 17.4805 10.2852 17.7517C10.7093 17.8779 11 18.2677 11 18.7101V20H13V18.7101C13 18.2677 13.2907 17.8779 13.7147 17.7517C14.6258 17.4805 15.4475 16.998 16.1223 16.3597C16.4436 16.0557 16.9264 15.999 17.3095 16.2201L18.4282 16.866L19.4282 15.134L18.3109 14.4889C17.9282 14.2679 17.7359 13.8219 17.8379 13.3919C17.9437 12.9462 18 12.4803 18 12C18 11.5197 17.9437 11.0538 17.8379 10.6081C17.7359 10.1781 17.9282 9.73206 18.3109 9.51108L19.4282 8.86603L18.4282 7.13397L17.3095 7.77986C16.9264 8.00101 16.4436 7.94425 16.1223 7.64031C15.4475 7.00201 14.6258 6.51949 13.7147 6.24833C13.2907 6.12213 13 5.73229 13 5.28987V4H11Z"
    }));
}

//# sourceMappingURL=Settings.js.map